import { GCModule } from '@business/constants/permissions';
import { UserResponse, UserRole } from '@business/entities/account';
import { LabelNameEnum } from '@business/entities/label';
import { isGCLabelActive } from '@core/utils/hooks/misc/gcLabel';
import { useObservable } from '@core/utils/hooks/rxjs';
import { R } from '@core/utils/r';
import { Session } from '@modules/auth/session';
import React, { Fragment, memo } from 'react';

export interface PermissionProviderProps {
  module: GCModule | GCModule[];
  children?: React.ReactNode;
  label?: LabelNameEnum;
}

export const PermissionProvider = memo((props: PermissionProviderProps) => {
  const { module, label } = props;
  const user = useObservable(Session.user$);
  if (label && !isGCLabelActive(label)) {
    return null;
  }

  if (!user) return null;
  if (user.role === UserRole.admin || R.isArray(module) ? isModulesActivate(user, module as GCModule[]) : isModuleActivate(user, module)) {
    return <Fragment>{props.children}</Fragment>;
  }
  return null;
});

export function isModuleActivate(user: UserResponse, module: GCModule) {
  return R.find(user.permissions, p => p.module === module)?.value !== false;
}

export function isModulesActivate(user: UserResponse, modules: GCModule[], isAny = false) {
  if (!modules) {
    return false;
  }
  const userModules = user.permissions.filter(p => modules.includes(p.module));
  if (isAny) {
    return userModules.reduce((acc, cur) => acc || cur.value, false);
  }
  return userModules.reduce((acc, cur) => acc && cur.value, true);
}
